import Head from "next/head";
import { Footer } from "./Footer";
import { HeaderMenu } from "./HeaderMenu";
import { ReactNode, useEffect, useState } from "react";
import { Popup } from "./Popup";
import { FooterWidget, NewMenu } from "../types/Menu";
import { PopupTypes } from "../types/Popup";
import parse from "html-react-parser";

type MainLayoutHead = {
  title?: string;
  customHeadData?: ReactNode;
};

type MainLayoutProps = {
  footerMenu?: FooterWidget;
  headerMenu?: Array<NewMenu>;
  head?: MainLayoutHead;
  siteTitle?: string;
  customStyle?: React.CSSProperties;
  children: ReactNode;
  popupData?: PopupTypes;
};

export default function MainLayout(props: MainLayoutProps) {
  const [showPopup, setShowPopup] = useState<boolean>(false);
  useEffect(() => {
    setTimeout(() => {
      setShowPopup(true);
    }, 5000);
  }, []);

  return (
    <>
      <Head>
        {!props?.head?.customHeadData ? (
          <>
            <title>
              {props?.head?.title ? props.head.title : "Blog Finanzero"}
            </title>
            <meta
              name="description"
              content="FinanZero é o seu buscador de empréstimos rápido e seguro! A gente busca as melhores taxas e você escolhe a melhor opção para o seu bolso."
            />
          </>
        ) : typeof props.head.customHeadData === "string" ? (
          parse(props.head.customHeadData)
        ) : (
          props.head.customHeadData
        )}
      </Head>
      <div style={props.customStyle}>
        <HeaderMenu items={props.headerMenu} />
        {props.children}
        <Footer
          footerMenu={props.footerMenu.footerMenu}
          sidebarRodape2={props.footerMenu.sidebarRodape2}
          stringData={props.footerMenu.stringData}
          footerOptions={props.footerMenu.footerOptions}
        />
        {props.popupData && showPopup && (
          <Popup popupData={props.popupData} setShowPopup={setShowPopup} />
        )}
      </div>
      <div id="root-lia_chat" />
    </>
  );
}
